<template>
  <div
    v-if="loading"
    class="row q-col-gutter-md"
  >
    <div
      v-for="item in Array(size)"
      :key="item"
      class="item col-12 col-sm-6 col-md-4 col-lg-3"
    >
      <ProductCardSkeleton />
    </div>
  </div>

  <div v-else>
    <div class="row q-col-gutter-md">
      <div
        v-for="item in items"
        :key="item.id"
        class="item col-12 col-sm-6 col-md-4 col-lg-3"
      >
        <ProductCard :product="item" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { whenever } from '@vueuse/core';
import type { Product } from '~/types/search';

const props = defineProps({
  items: {
    type: Array as PropType<Product[]>,
    required: true,
  },
  size: {
    type: Number,
    default: 24,
  },
  loading: {
    type: Boolean,
  },
});

const collection = useCollection();
const { $bus } = useNuxtApp();

whenever(
  () => !!props.items.length,
  () => $bus.emit('catalog:view', props.items, collection),
  {
    immediate: true,
  },
);
</script>

<style lang="scss" scoped>
@media (min-width: 1920px) {
  .row > .item {
    height: auto;
    width: 20%;
  }
}
</style>
